module.exports = function getResource(label, vars = []) {
    let resources = {
        viewShippedBasket: `${vars[0] ? '' : 'Consultez votre '}panier d’articles à faire livrer`,
        viewPickupBasket: `${vars[0] ? '' : 'Consultez votre '}panier d’articles « Achetez en ligne, ramassez en magasin »`
    };

    return resources[label];
};
